import { AddMenuItemAction, OrderingInitialState } from '@reducers/ordering/types';
import { v4 as uuidV4 } from 'uuid';

const addFreeMenuItem = (state: OrderingInitialState, action: AddMenuItemAction): OrderingInitialState => {
  const { menuItem: itemToAdd } = action.payload;

  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: [
        ...state.orderState.menus,
        {
          menuItemId: itemToAdd?.id || '',
          tempId: uuidV4(),
          count: 1,
          discount: itemToAdd.discount,
          title: itemToAdd?.title || '',
          price: itemToAdd.price,
          packagingCost: 0,
          servePackagingCost: 0,
          changePrice: false,
          orderItemToppings: [],
          withTax: false,
          isFreeItem: true,
        },
      ],
      isMenuItemDetailsVisible: false,
      selectedTopping: [],
      menuItemsCount: 0,
    },
  };
};

export const addMenuItem = (state: OrderingInitialState, action: AddMenuItemAction): OrderingInitialState => {
  const { menuItem: itemToAdd } = action.payload;

  if (action.payload.isFreeItem === true) return addFreeMenuItem(state, action);

  const existMenu = state.orderState.menus.filter((x) => x.menuItemId === itemToAdd?.id && !x.isFreeItem);

  const exist = existMenu?.some((x) => {
    const check =
      action.payload?.selectedToppings?.length === x?.orderItemToppings?.length &&
      action.payload?.selectedToppings?.every((y) => x?.orderItemToppings?.map((z) => z.toppingId).includes(y?.id));
    return check;
  });

  const menuItemsCount = state.orderState.menus?.map((item) => item.count || 0).reduce((a, b) => a + b, 1);

  if (exist) {
    return {
      ...state,
      orderState: {
        ...state.orderState,
        menus: state.orderState.menus.map((item) => {
          if (
            item.menuItemId === itemToAdd.id &&
            action.payload?.selectedToppings.length === item?.orderItemToppings?.length &&
            action.payload?.selectedToppings.every((y) =>
              item?.orderItemToppings?.map((z) => z.toppingId).includes(y?.id)
            ) &&
            !item?.isFreeItem
          ) {
            return {
              ...item,
              count: (item?.count || 0) + 1,
              orderItemToppings: item?.orderItemToppings?.map((x) => ({
                ...x,
                count: (item.count || 0) + 1,
              })),
              withTax: item?.withTax,
            };
          }
          return item;
        }),
        isMenuItemDetailsVisible: false,
        selectedTopping: [],
        menuItemsCount,
      },
    };
  }

  return {
    ...state,
    orderState: {
      ...state.orderState,
      menus: [
        ...state.orderState.menus,
        {
          count: 1,
          discount: itemToAdd?.discount || 0,
          menuItemId: itemToAdd?.id || '',
          title: itemToAdd?.title || '',
          price: itemToAdd?.price || 0,
          packagingCost: itemToAdd?.packagingCost || 0,
          servePackagingCost: itemToAdd?.servePackagingCost || 0,
          tempId: uuidV4(),
          changePrice: false,
          orderItemToppings: action.payload?.selectedToppings?.map((x) => ({
            count: 1,
            price: x.price,
            title: x.title,
            toppingId: x.id,
          })),
          withTax: itemToAdd?.withTax,
        },
      ],
      isMenuItemDetailsVisible: false,
      selectedTopping: [],
      menuItemsCount,
    },
  };
};
